<template>
    <router-link component="NavButton" :state="getState" :to="getTo" :size="size" :color="color">
        <i class="icon" v-if="icon">{{ icon }}</i>
        <span v-if="text" class="text">{{ text }}</span>
        <span v-if="html" class="text" v-html="html"></span>
    </router-link>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'NavButton',

    props: {
        icon: {
            type: String,
        },

        text: {
            type: String,
        },

        html: {
            type: String,
        },

        link: {
            type: String,
        },

        to: {
            type: String | Object,
        },

        size: {
            type: String,
        },

        color: {
            type: String,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        getTo() {
            if (this.link) return { path: this.link };
            return this.to;
        },

        getState() {
            return this.tempState || (this.disabled === true ? 'disabled' : false) || this.state;
        },
    },
};
</script>
